/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LockedSlotPhysician } from './LockedSlotPhysician';
import {
    LockedSlotPhysicianFromJSON,
    LockedSlotPhysicianFromJSONTyped,
    LockedSlotPhysicianToJSON,
} from './LockedSlotPhysician';

/**
 * 
 * @export
 * @interface AppointmentSlot
 */
export interface AppointmentSlot {
    /**
     * 
     * @type {number}
     * @memberof AppointmentSlot
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof AppointmentSlot
     */
    end?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentSlot
     */
    physicians?: Array<string>;
    /**
     * Practitioners who have this slot free but are bookable only on a plan the requesting patient is not on. Never overlaps with `physicians`. Only present for patient-role callers.
     * @type {Array<LockedSlotPhysician>}
     * @memberof AppointmentSlot
     */
    locked_physicians?: Array<LockedSlotPhysician>;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentSlot
     */
    has_follow_up?: boolean;
}

/**
 * Check if a given object implements the AppointmentSlot interface.
 */
export function instanceOfAppointmentSlot(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AppointmentSlotFromJSON(json: any): AppointmentSlot {
    return AppointmentSlotFromJSONTyped(json, false);
}

export function AppointmentSlotFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentSlot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'start': !exists(json, 'start') ? undefined : json['start'],
        'end': !exists(json, 'end') ? undefined : json['end'],
        'physicians': !exists(json, 'physicians') ? undefined : json['physicians'],
        'locked_physicians': !exists(json, 'locked_physicians') ? undefined : ((json['locked_physicians'] as Array<any>).map(LockedSlotPhysicianFromJSON)),
        'has_follow_up': !exists(json, 'has_follow_up') ? undefined : json['has_follow_up'],
    };
}

export function AppointmentSlotToJSON(value?: AppointmentSlot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start': value.start,
        'end': value.end,
        'physicians': value.physicians,
        'locked_physicians': value.locked_physicians === undefined ? undefined : ((value.locked_physicians as Array<any>).map(LockedSlotPhysicianToJSON)),
        'has_follow_up': value.has_follow_up,
    };
}

